import { render, staticRenderFns } from "./AgentBase.vue?vue&type=template&id=053be2f8&scoped=true&"
import script from "./AgentBase.vue?vue&type=script&lang=js&"
export * from "./AgentBase.vue?vue&type=script&lang=js&"
import style0 from "./AgentBase.vue?vue&type=style&index=0&id=053be2f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053be2f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})


/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})
